import { Component } from 'react'
import styles from '~/styles/ordersPage.statuses.module.css'
import types from '~/types/ordersPage.ts'

export const straightWay = ['HOLD','CREATED','FULFILLMENT','APPROVED','FIRST_MILE','IN_PROGRESS','PLACED_IN_POSTAMAT','EXPIRING','PICKED_UP']
export const unclaimedWay = [ 'UNCLAIMED', 'RETURNING', 'RETURNED' ]
export const problemWay = [ 'CANCEL_REQUEST', 'CANCELLED', 'PROBLEM', 'REJECTED' ]
export const orderStatuses = [ ...straightWay, ...unclaimedWay, ...problemWay ]
export const fulfillmentStatuses = {
	'CREATE_ORDER': 'Start processing',
	'HOLD': 'Hold processing',
	'declined': 'Cancel processing',
}
export const statusesToFulfillment = {
	'Start processing': 'CREATE_ORDER',
	'Hold processing': 'HOLD',
	'Cancel processing': 'declined',
}

export default class Statuses extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders', 'common' ],
		}
	}
	
	constructor(props) {
		super(props)
		this._fulfillmentStatuses = JSON.parse(JSON.stringify(fulfillmentStatuses))
		if (!this.props.cancelAble) {
			delete this._fulfillmentStatuses['declined']
		}
		if (this._fulfillmentStatuses[this.props.currentStatus]) {
			if (this.props.order.status !== 'HOLD') {
				delete this._fulfillmentStatuses[this.props.currentStatus]
			}
		}
		if (this.props.fulfillmentStatus) {
			if (!this._fulfillmentStatuses[this.props.fulfillmentStatus]) {
				this._fulfillmentStatuses[this.props.fulfillmentStatus] = this.props.fulfillmentStatus
			}
		}
		this.state = {
			currentKey: this.props.fulfillmentStatus || Object.keys(this._fulfillmentStatuses)[0],
		}
	}
	
	render(): JSX.Element {
		const defaultKey = this.state.currentKey
		const defaultValue = this.props.t(this._fulfillmentStatuses[defaultKey])
		return (
			<div
				className={styles.main}
			>
				<select
					value={defaultValue}
					onChange={this._onChange.bind(this)}
				>
					{this._getOptions()}
				</select>
			</div>
		)
	}
	
	private _getOptions(): Array<JSX.Element> {
		let options: Array<JSX.Element> = []
		let firstValue = this._fulfillmentStatuses[this.props.fulfillmentStatus]
		if (firstValue) {
			options.push(this._getOption(this.props.fulfillmentStatus, this.props.t(firstValue), firstValue))
		}
		Object.keys(this._fulfillmentStatuses).forEach(key => {
			if (key !== this.props.fulfillmentStatus) {
				const value = this.props.t(this._fulfillmentStatuses[key])
				options.push(this._getOption(key, value, this._fulfillmentStatuses[key]))
			}
		})
		return options
	}
	
	private _getOption(key: string, value: string, keyValue: string): JSX.Element {
		return (
			<option
				key={key}
				keyvalue={keyValue}
			>
				{value}
			</option>
		)
	}
	
	private _onChange(event): void {
		const value = event?.target?.value
		const keyValue = event?.target?.options[event?.target?.selectedIndex]?.getAttribute('keyvalue')
		let key = Object.keys(this._fulfillmentStatuses).find(key => this._fulfillmentStatuses[key] === (keyValue || value))
		if (key) {
			this.setState({ currentKey: key })
			if (this.props.onChange) {
				if ((key===this.props.fulfillmentStatus) && !fulfillmentStatuses[this.props.fulfillmentStatus] && this.props.currentStatus) {
					key = this.props.currentStatus
				}
				this.props.onChange({
					fulfillmentStatus: key,
				})
			}
		}
	}
}